const tab_sections = {
    overview: 'Przegląd',
    authentication: 'Uwierzytelnianie',
    authorization: 'Autoryzacja',
    users: 'Użytkownicy',
    developer: 'Deweloper',
    tenant: 'Najemca',
};
export default Object.freeze(tab_sections);
